import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

// Admin-only: keeps the year's signed tuition agreement as it is, with the office's reason.
const KeepTuitionAgreement = graphql.persisted(
  "KeepTuitionAgreement",
  graphql(`
    mutation KeepTuitionAgreement($familyEnrollmentId: ID!, $reason: String!) {
      keepTuitionAgreement(input: { familyEnrollmentId: $familyEnrollmentId, reason: $reason }) {
        item { id title round state waivedReason keptAsItIs }
        userErrors { message path }
      }
    }
  `)
);

export { KeepTuitionAgreement };

export function useKeepTuitionAgreement() {
  return useMutation(KeepTuitionAgreement);
}
